import React, { useState, useEffect } from 'react'
import { Modal, Row, Col, Input, Button, Form } from 'antd';
import { translate } from 'react-i18next'
import { checkTokenExpire } from './../../redux/actions/actions'
import {  useDispatch } from 'react-redux'

const ModalEditParticipant = ({ visible, title, setEditParticipant, t, userInfo, handleChatApi }) => {
   
    const [form] = Form.useForm()
    const [name, setName] = useState('')
    const [nameError, setnameError] = useState(false)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        
        form.setFieldsValue({
            name: userInfo.name
               
        })
           
        
       
    }, [form , userInfo.name])

 
    const handleCancel = () => {
        setEditParticipant(false)
        setnameError(false)
        form.setFieldsValue({
            name: userInfo.name
            
         })
        
    };


    const onAuthenRocket = () => {
        dispatch(checkTokenExpire)
        if (name !== '') {
            setLoading(true)
            const user = { ...userInfo, name }
            handleChatApi(user)
            setTimeout(() => {
                setLoading(false)
                setEditParticipant(false)
                
            }, 900);
        }
        
       
    }


    const onSetName = (input) => {
        
        if (input.target.value === "") {
            setnameError(true)
           
        } else {
            setnameError(false)
          
        }
        setName(input.target.value)

    }

    const onInputKeydown = (event) => {
        var code = event.keyCode || event.which;
        if (code === 13) {
            if (name !== '') {
                const user = { ...userInfo, name }
               
                setName(user.name)
                handleChatApi(user)
                setEditParticipant(false)
            }
        }
    }

    return (
        <>
            <Modal
                title={title}
                visible={visible}
                onCancel={handleCancel}
                footer={[
                    <Button form="modal-reservation-form" key="submit" className="btn-submit-join-vroom" loading={loading} onClick={onAuthenRocket} >
                     {/* <Button form="modal-reservation-form" key="submit" className="btn-submit-join-vroom" loading={loading} onClick={onSetProfileRocketChat} > */}
                        {t("lobby_modal.OK")}
                    </Button>,
                    <Button key="back" type="text" className="btn-cancel-join-vroom" onClick={handleCancel}>
                        {t("lobby_modal.cancel")}
                    </Button>
                ]}
            >
                <Row className="modal-input-join-vroom">
                    <Col span={24}>
                        <Form
                        layout="vertical"
                         form={form}
                         name="modal-reservation-form"
                         
                        >
                            <div className="join-v-room-name-input">
                                <Form.Item name="name" label={t("lobby_modal.name")}>
                                    <Input type="text" name="name" maxLength={50}  onKeyPress={onInputKeydown.bind(this)} onChange={(e) => onSetName(e)} />
                                </Form.Item>
                                
                            </div>
                            {nameError ? (
                                <span className="red-text">{`${t('lobby_modal.name_invalid')}`}</span>
                            ) : null
                            }
                        </Form>
                        
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

export default translate()(ModalEditParticipant)
